import * as Endpoints from "../../entities/Endpoints";

export const CONSTANTS = {
  // client check-in constants
  MEALS: "Meals",
  WORKOUT: "Workout",
  PAYMENT: "Payment",
  INFO: "Info",
  CHECKIN: "CheckIn",

  // Toast notification constants
  TOAST_SUCCESS: "success",
  TOAST_ERROR: "error",
  TOAST_WARNING: "warning",
  TOAST_INFO: "info",
  TOAST_DURATION_SHORT: 3000,
  TOAST_DURATION_LONG: 8000,
  RECEIVE_MESSAGE: "ReceiveMessage",

  // Meals
  DAILY_INTAKE: "dailyIntake",
  // 1 to 100 constants
  ZERO: 0,
  ONE: 1,
  TWO: 2,
  THREE: 3,
  FOUR: 4,
  FIVE: 5,
  SIX: 6,
  SEVEN: 7,
  EIGHT: 8,
  NINE: 9,
  TEN: 10,
  ELEVEN: 11,
  TWELVE: 12,
  THIRTEEN: 13,
  FOURTEEN: 14,
  FIFTEEN: 15,
  SIXTEEN: 16,
  SEVENTEEN: 17,
  EIGHTEEN: 18,
  NINETEEN: 19,
  TWENTY: 20,
  TWENTY_ONE: 21,
  TWENTY_TWO: 22,
  TWENTY_THREE: 23,
  TWENTY_FOUR: 24,
  TWENTY_FIVE: 25,
  TWENTY_SIX: 26,
  TWENTY_SEVEN: 27,
  TWENTY_EIGHT: 28,
  TWENTY_NINE: 29,
  THIRTY: 30,
  THIRTY_ONE: 31,
  THIRTY_TWO: 32,
  THIRTY_THREE: 33,
  THIRTY_FOUR: 34,
  THIRTY_FIVE: 35,
  THIRTY_SIX: 36,
  THIRTY_SEVEN: 37,
  THIRTY_EIGHT: 38,
  THIRTY_NINE: 39,
  FORTY: 40,
  FORTY_ONE: 41,
  FORTY_TWO: 42,
  FORTY_THREE: 43,
  FORTY_FOUR: 44,
  FORTY_FIVE: 45,
  FORTY_SIX: 46,
  FORTY_SEVEN: 47,
  FORTY_EIGHT: 48,
  FORTY_NINE: 49,
  FIFTY: 50,
  FIFTY_ONE: 51,
  FIFTY_TWO: 52,
  FIFTY_THREE: 53,
  FIFTY_FOUR: 54,
  FIFTY_FIVE: 55,
  FIFTY_SIX: 56,
  FIFTY_SEVEN: 57,
  FIFTY_EIGHT: 58,
  FIFTY_NINE: 59,
  SIXTY: 60,
  SIXTY_ONE: 61,
  SIXTY_TWO: 62,
  SIXTY_THREE: 63,
  SIXTY_FOUR: 64,
  SIXTY_FIVE: 65,
  SIXTY_SIX: 66,
  SIXTY_SEVEN: 67,
  SIXTY_EIGHT: 68,
  SIXTY_NINE: 69,
  SEVENTY: 70,
  SEVENTY_ONE: 71,
  SEVENTY_TWO: 72,
  SEVENTY_THREE: 73,
  SEVENTY_FOUR: 74,
  SEVENTY_FIVE: 75,
  SEVENTY_SIX: 76,
  SEVENTY_SEVEN: 77,
  SEVENTY_EIGHT: 78,
  SEVENTY_NINE: 79,
  EIGHTY: 80,
  EIGHTY_ONE: 81,
  EIGHTY_TWO: 82,
  EIGHTY_THREE: 83,
  EIGHTY_FOUR: 84,
  EIGHTY_FIVE: 85,
  EIGHTY_SIX: 86,
  EIGHTY_SEVEN: 87,
  EIGHTY_EIGHT: 88,
  EIGHTY_NINE: 89,
  NINETY: 90,
  NINETY_ONE: 91,
  NINETY_TWO: 92,
  NINETY_THREE: 93,
  NINETY_FOUR: 94,
  NINETY_FIVE: 95,
  NINETY_SIX: 96,
  NINETY_SEVEN: 97,
  NINETY_EIGHT: 98,
  NINETY_NINE: 99,
  HUNDRED: 100,
  INVALID_DATE: "Invalid date",

  /// WORKOUT PLAN
  DEFAULT_NAME: "Default Name",
  NOTES: "notes",
  ERROR_WORKOUT_IMAGE: "Error converting workout plan image to base64:",
  SIX_SESSION_EMPTY: "6 sessions empty template",
  SESSION_ONE: "Session 1",
  SESSION_TWO: "Session 2",
  SESSION_THREE: "Session 3",
  SESSION_FOUR: "Session 4",
  SESSION_FIVE: "Session 5",
  SESSION_SIX: "Session 6",
  BARBELL: "Barbell",
  FAILED_TO_FETCH: "Failed to fetch workout plan:",
  TRAINING_LOCATION: "Training Location",
  TRAINING_EXPERIENCE: "Training Experience",
  TRAINING_SCHEDULE: "Training Schedule",
  TRAINING_EQUIPMENT: "Training Equipment",
  VALUE_LESS_THAN_ZERO: "Values cant be lesser than zero !!",
  WORKOUT_PLAN_COVER: "workoutPlanCover",
  COURSE: "COURSE",
};

export const CATEGORY_TICKET = [
  { value: null, label: "Select" },
  { value: 1, label: "Meal Plan" },
  { value: 2, label: "Workout Plan" },
  { value: 3, label: "Client" },
  { value: 4, label: "Messenger" },
  { value: 5, label: "Leads" },
  { value: 6, label: "Website" },
  { value: 7, label: "Billing" },
  { value: 8, label: "Toolbox" },
];

export const MEAL_PLAN_TYPES = {
  TWO_MEALS: "2Meals",
  THREE_MEALS: "3Meals",
  THREE_MEALS_ONE_SNACK: "3Meals1Snack",
  THREE_MEALS_TWO_SNACKS: "3Meals2Snacks",
  FOUR_MEALS: "4Meals",
  FOUR_MEALS_ONE_SNACK: "4Meals1Snack",
};

export const mealTime = [
  { value: "", label: "Course" },
  { value: "BREAKFAST", label: "Breakfast" },
  { value: "LUNCH", label: "Lunch" },
  { value: "DINNER", label: "Dinner" },
  { value: "SNACK", label: "Snack" },
];

export const mealTimeAI = [
  { value: "", label: "Select" },
  { value: "Breakfast", label: "Breakfast" },
  { value: "Lunch", label: "Lunch" },
  { value: "Dinner", label: "Dinner" },
  { value: "Snack", label: "Snack" },
];

export const RepsItems = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
];

export const nutrientColors = [
  "#800080",
  "#FFA500",
  "#007BFF",
  "#FF6347",
  "#2E8B57",
  "#8B4513",
  "#DC143C",
  "#4682B4",
  "#20B2AA",
  "#DAA520",
];

export const nutrientDescriptionMap = {
  fiber: "fiberDescription",
  iron: "ironDescription",
  calcium: "calciumDescription",
  vitaminD: "vitaminDDescription",
  vitaminB12: "vitaminB12Description",
  magnesium: "magnesiumDescription",
  sodium: "sodiumDescription",
  potassium: "potassiumDescription",
  vitaminA: "vitaminADescription",
  vitaminC: "vitaminCDescription",
  sugar: "sugarDescription",
};
export const languages = [
  { value: "", label: "Select Language" },
  { value: "English", label: "English" },
  { value: "Spanish", label: "Spanish" },
  { value: "French", label: "French" }
];

export function parseLocalDate(dateString) {
  if (!dateString) return null;
  const parts = dateString.split("-");
  if (parts.length !== 3) return null;
  const year = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1;
  const day = parseInt(parts[2], 10);
  return new Date(year, month, day);
}

export const planSummary = {
  averageProtein: 18.01,
  averageFat: 26.32,
  averageCarbs: 24.04,
  averageCalories: 810.21,
  averageFiber: 3.145,
  averageCalcium: 417.04,
  averageIron: 6.6,
  averageVitaminD: 0.02,
  averageVitaminB12: 8.505,
  averageMagnesium: 62.75,
  proteinPercentage: 17.78,
  fatPercentage: 58.48,
  carbsPercentage: 23.74,
  caloriesPercentage: 800.05,
  fiberPercentage: 3.11,
  ironPercentage: 6.52,
  calciumPercentage: 411.81,
  vitaminDPercentage: 0.02,
  vitaminB12Percentage: 8.4,
  magnesiumPercentage: 61.96,
};
export const LanguageItems = ["English", "Spanish", "French"];

export const MEAL_CATEGORIES = {
  BREAKFAST: "BREAKFAST",
  LUNCH: "LUNCH",
  LUNCH1: "LUNCH1",
  DINNER: "DINNER",
  SNACK: "SNACK",
  SNACK1: "SNACK1",
};

export const MEAL_TYPES = {
  BREAKFAST: "Breakfast",
  LUNCH: "Lunch",
  LUNCH1: "Lunch1",
  DINNER: "Dinner",
  SNACK: "Snack",
  SNACK1: "Snack1",
};

export const nutrientUnits = {
  calories: "kcal",
  calcium: "mg",
  iron: "mg",
  magnesium: "mg",
  vitaminD: "µg",
  vitaminB12: "µg",
  vitaminA: "µg",
  vitaminC: "mg",
  saturatedFat: "g",
  monounsaturatedFat: "g",
  transFat: "g",
  cholesterol: "mg",
  sodium: "mg",
  potassium: "mg",
  fiber: "g",
  netcarbs: "g",
  sugar: "g",
};

// meal plan type to meal categories mapping
export const mealPlanMap = {
  [MEAL_PLAN_TYPES.TWO_MEALS]: [MEAL_CATEGORIES.LUNCH, MEAL_CATEGORIES.DINNER],
  [MEAL_PLAN_TYPES.THREE_MEALS]: [
    MEAL_CATEGORIES.BREAKFAST,
    MEAL_CATEGORIES.LUNCH,
    MEAL_CATEGORIES.DINNER,
  ],
  [MEAL_PLAN_TYPES.THREE_MEALS_ONE_SNACK]: [
    MEAL_CATEGORIES.BREAKFAST,
    MEAL_CATEGORIES.LUNCH,
    MEAL_CATEGORIES.DINNER,
    MEAL_CATEGORIES.SNACK,
  ],
  [MEAL_PLAN_TYPES.THREE_MEALS_TWO_SNACKS]: [
    MEAL_CATEGORIES.BREAKFAST,
    MEAL_CATEGORIES.LUNCH,
    MEAL_CATEGORIES.DINNER,
    MEAL_CATEGORIES.SNACK,
    MEAL_CATEGORIES.SNACK1,
  ],
  [MEAL_PLAN_TYPES.FOUR_MEALS]: [
    MEAL_CATEGORIES.BREAKFAST,
    MEAL_CATEGORIES.LUNCH,
    MEAL_CATEGORIES.LUNCH1,
    MEAL_CATEGORIES.DINNER,
  ],
  [MEAL_PLAN_TYPES.FOUR_MEALS_ONE_SNACK]: [
    MEAL_CATEGORIES.BREAKFAST,
    MEAL_CATEGORIES.LUNCH,
    MEAL_CATEGORIES.DINNER,
    MEAL_CATEGORIES.SNACK,
    MEAL_CATEGORIES.LUNCH1,
  ],
};

// Default percentage presets
export const MEAL_PERCENTAGE_DEFAULTS = {
  [MEAL_PLAN_TYPES.TWO_MEALS]: {
    [MEAL_CATEGORIES.LUNCH]: 45,
    [MEAL_CATEGORIES.DINNER]: 55,
  },
  [MEAL_PLAN_TYPES.THREE_MEALS]: {
    [MEAL_CATEGORIES.BREAKFAST]: 30,
    [MEAL_CATEGORIES.LUNCH]: 35,
    [MEAL_CATEGORIES.DINNER]: 35,
  },
  [MEAL_PLAN_TYPES.THREE_MEALS_ONE_SNACK]: {
    [MEAL_CATEGORIES.BREAKFAST]: 26,
    [MEAL_CATEGORIES.LUNCH]: 31,
    [MEAL_CATEGORIES.DINNER]: 31,
    [MEAL_CATEGORIES.SNACK]: 12,
  },
  [MEAL_PLAN_TYPES.THREE_MEALS_TWO_SNACKS]: {
    [MEAL_CATEGORIES.BREAKFAST]: 24,
    [MEAL_CATEGORIES.LUNCH]: 28,
    [MEAL_CATEGORIES.DINNER]: 28,
    [MEAL_CATEGORIES.SNACK]: 10,
    [MEAL_CATEGORIES.SNACK1]: 10,
  },
  [MEAL_PLAN_TYPES.FOUR_MEALS]: {
    [MEAL_CATEGORIES.BREAKFAST]: 25,
    [MEAL_CATEGORIES.LUNCH]: 25,
    [MEAL_CATEGORIES.LUNCH1]: 25,
    [MEAL_CATEGORIES.DINNER]: 25,
  },
  [MEAL_PLAN_TYPES.FOUR_MEALS_ONE_SNACK]: {
    [MEAL_CATEGORIES.BREAKFAST]: 22,
    [MEAL_CATEGORIES.LUNCH]: 22,
    [MEAL_CATEGORIES.DINNER]: 22,
    [MEAL_CATEGORIES.LUNCH1]: 22,
    [MEAL_CATEGORIES.SNACK]: 12,
  },
};

export const DIETARY_CONFLICTS_BY_NAME = {
  Pescatarian: ["Vegan"],
  Vegan: ["Perscatarian", "Pescatarian", "Halal", "Kosher", "Dairy-Free"],
  Halal: ["Vegan", "Kosher"],
  Kosher: ["Vegan", "Halal"],
  "Dairy-Free": ["Vegan"],
};

// Workout builder 
// Allowed static image MIME types — no GIF or animated formats
export const ALLOWED_IMAGE_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/webp",
];

export const SKIP_TOKEN_URLS = [
  Endpoints.GET_COACH_ONBOARDING_PROCESS,
  Endpoints.GET_CLIENT_CHECKOUT_SESSION,
  Endpoints.GET_MOBILE_APP_DETAILS,
  Endpoints.UPDATE_CLIENT_PAYMENT_METHOD,
  Endpoints.ADD_CUSTOMER_PAYMENT_METHOD_STRIPE_FOR_CLIENT
];